(function () {
  function buildEstimatorHref(baseUrl, materialApiName) {
    try {
      var url = new URL(baseUrl, window.location.origin);
      if (materialApiName) {
        url.searchParams.set('material', materialApiName);
      } else {
        url.searchParams.delete('material');
      }
      return url.pathname + url.search + url.hash;
    } catch (e) {
      return baseUrl;
    }
  }

  function goToEstimator(root, materialApiName) {
    var baseUrl = root.getAttribute('data-estimateur-url') || '/pages/estimateur';
    var onEstimatorPage =
      window.location.pathname === new URL(baseUrl, window.location.origin).pathname;

    if (onEstimatorPage && typeof window.openEstimatorWithMaterial === 'function') {
      window.openEstimatorWithMaterial(materialApiName || '');
      return;
    }

    window.location.href = buildEstimatorHref(baseUrl, materialApiName);
  }

  function initHeroSection(root) {
    var filters = root.querySelectorAll('[data-ist-filter]');
    var materials = root.querySelectorAll('[data-ist-material]');
    var emptyState = root.querySelector('[data-ist-empty]');
    var startBtn = root.querySelector('[data-ist-start]');
    var startLinks = root.querySelectorAll('[data-ist-start-link]');
    var selectedLabel = root.querySelector('[data-ist-selected-name]');
    var materialLink = root.querySelector('[data-ist-material-link]');
    var baseUrl = root.getAttribute('data-estimateur-url') || '/pages/estimateur';

    var selectedMaterial = null;
    var selectedMaterialUrl = '';

    function updateStartHref() {
      var href = buildEstimatorHref(baseUrl, selectedMaterial);
      if (startBtn) {
        startBtn.setAttribute('href', href);
      }
      startLinks.forEach(function (link) {
        link.setAttribute('href', href);
      });
    }

    function getVisibleMaterials() {
      return Array.from(materials).filter(function (m) {
        return m.dataset.hidden !== 'true';
      });
    }

    function updateEmptyState() {
      if (!emptyState) return;
      var visible = getVisibleMaterials();
      emptyState.hidden = visible.length > 0;
    }

    function selectMaterial(btn) {
      if (!btn || btn.dataset.hidden === 'true') return;

      materials.forEach(function (m) {
        m.classList.remove('is-selected');
        m.setAttribute('aria-selected', 'false');
      });

      btn.classList.add('is-selected');
      btn.setAttribute('aria-selected', 'true');
      selectedMaterial = btn.getAttribute('data-material-api') || btn.getAttribute('data-material-name') || '';
      selectedMaterialUrl = btn.getAttribute('data-material-url') || '';

      if (selectedLabel) {
        selectedLabel.textContent = btn.getAttribute('data-material-name') || selectedMaterial;
      }

      if (materialLink) {
        if (selectedMaterialUrl) {
          materialLink.href = selectedMaterialUrl;
          materialLink.hidden = false;
        } else {
          materialLink.hidden = true;
        }
      }

      updateStartHref();
    }

    function applyFilter(filter) {
      filters.forEach(function (f) {
        f.classList.toggle('is-active', f.getAttribute('data-ist-filter') === filter);
      });

      materials.forEach(function (m) {
        var categories = (m.getAttribute('data-categories') || '').split(',').map(function (s) {
          return s.trim();
        });
        var show = filter === 'all' || categories.includes(filter);
        m.dataset.hidden = show ? 'false' : 'true';
        m.hidden = !show;
      });

      updateEmptyState();

      var currentSelected = root.querySelector('[data-ist-material].is-selected');
      if (!currentSelected || currentSelected.dataset.hidden === 'true') {
        var visible = getVisibleMaterials();
        if (visible[0]) selectMaterial(visible[0]);
      }
    }

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyFilter(btn.getAttribute('data-ist-filter'));
      });
    });

    materials.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectMaterial(btn);
      });
    });

    var preselected = root.querySelector('[data-ist-material].is-selected');
    if (preselected) {
      selectMaterial(preselected);
    } else if (materials[0]) {
      selectMaterial(materials[0]);
    } else {
      updateStartHref();
    }

    if (startBtn) {
      startBtn.addEventListener('click', function (e) {
        var onEstimatorPage =
          window.location.pathname === new URL(baseUrl, window.location.origin).pathname;
        if (onEstimatorPage) {
          e.preventDefault();
          goToEstimator(root, selectedMaterial);
        }
      });
    }

    startLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var onEstimatorPage =
          window.location.pathname === new URL(baseUrl, window.location.origin).pathname;
        if (onEstimatorPage) {
          e.preventDefault();
          goToEstimator(root, selectedMaterial);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ist-hero]').forEach(initHeroSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target.querySelector('[data-ist-hero]');
    if (hero) initHeroSection(hero);
  });
})();
